import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { PMCConfig } from '@kyruus/types';
import {
  ExtendedProvider,
  FullAppointmentInfo,
  SearchSummary,
  Log
} from 'Src/types';
import { CtaListItemBase } from './CtaListItemBase';
import { messages, useBookOnlineButton } from '../../lib';

interface BaseBookOnlineListItemProps {
  provider: ExtendedProvider;
  config: PMCConfig;
  apptOptions?: FullAppointmentInfo;
  searchSummary?: SearchSummary;
  log: Log;
}

type BookOnlineListItemProps = BaseBookOnlineListItemProps &
  WrappedComponentProps &
  RouteComponentProps;

const BookOnlineListItemComponent = injectIntl(
  ({
    provider,
    config,
    apptOptions,
    searchSummary,
    history,
    location,
    log,
    intl
  }: BookOnlineListItemProps) => {
    const primaryText = intl.formatMessage(messages.bookOnlineTitle);
    const secondaryText =
      intl.formatMessage(messages.bookOnlineSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.bookOnlineSubtitle);
    const buttonProps = useBookOnlineButton({
      provider,
      config,
      apptOptions,
      searchSummary,
      location,
      history,
      log,
      primaryText,
      secondaryText
    });

    const isExternalLink = buttonProps?.target === '_blank';
    return (
      <CtaListItemBase
        buttonProps={buttonProps}
        isExternalLink={isExternalLink}
        primaryText={primaryText}
        secondaryText={secondaryText}
      />
    );
  }
);

export const BookOnlineListItem = withRouter(
  BookOnlineListItemComponent
) as any as (props: BaseBookOnlineListItemProps) => React.ReactElement;
